import React from "react";
import SEO from "../components/SEO";
import { businessInfo } from "../data/content";

export default function Privacy() {
  return (
    <>
      <SEO
        title="Politique de confidentialité | Pereira Plomberie Chauffage"
        description="Politique de confidentialité du site Pereira Plomberie Chauffage. Informations sur la collecte et le traitement de vos données personnelles."
      />

      <section className="bg-primary text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight" data-testid="privacy-title">
            Politique de confidentialité
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate prose-sm">
          <h2 className="font-heading text-xl font-bold uppercase tracking-tight">Collecte des données</h2>
          <p>
            Lorsque vous utilisez le formulaire de contact de notre site, nous collectons les informations suivantes :
            nom, téléphone, adresse email, ville, type de demande et message. Ces données sont nécessaires au traitement
            de votre demande et ne sont transmises à aucun tiers.
          </p>

          <h2 className="font-heading text-xl font-bold uppercase tracking-tight mt-8">Finalité du traitement</h2>
          <p>
            Les données collectées sont utilisées exclusivement pour :<br />
            - répondre à votre demande de contact ou de devis,<br />
            - assurer le suivi de votre demande,<br />
            - vous recontacter si nécessaire.
          </p>

          <h2 className="font-heading text-xl font-bold uppercase tracking-tight mt-8">Durée de conservation</h2>
          <p>
            Vos données sont conservées pour une durée maximale de 3 ans à compter de votre dernier contact,
            sauf obligation légale contraire.
          </p>

          <h2 className="font-heading text-xl font-bold uppercase tracking-tight mt-8">Vos droits</h2>
          <p>
            Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :<br />
            - Droit d'accès à vos données<br />
            - Droit de rectification<br />
            - Droit de suppression<br />
            - Droit à la portabilité<br />
            - Droit d'opposition au traitement
          </p>
          <p>
            Pour exercer ces droits, contactez-nous par email à{" "}
            <a href={businessInfo.emailLink}>{businessInfo.email}</a> ou par courrier à l'adresse :
            {businessInfo.address.full}.
          </p>

          <h2 className="font-heading text-xl font-bold uppercase tracking-tight mt-8">Cookies</h2>
          <p>
            Ce site n'utilise pas de cookies de suivi, de personnalisation ou publicitaires.
            Seul un cookie technique strictement nécessaire peut être déposé pour mémoriser
            l'affichage du bandeau d'information cookies.
          </p>
          <p>
            <strong>Nom :</strong> ppc_cookie_notice_ack<br />
            <strong>Finalité :</strong> mémoriser votre prise d'information sur le bandeau cookies<br />
            <strong>Durée de conservation :</strong> 6 mois<br />
            <strong>Base légale :</strong> exempté de consentement car strictement nécessaire au fonctionnement du site
          </p>
          <p>
            Vous pouvez supprimer ce cookie à tout moment depuis les paramètres de votre navigateur.
            Aucun cookie de mesure d'audience n'est activé sur ce site.
          </p>
        </div>
      </section>
    </>
  );
}
